import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from '@reach/router';

const WebMenu = (props) => {
  const { tabs } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const handleRoute = (href, external = false) => {
    if (external) {
      // eslint-disable-next-line no-undef
      window.open(href, '_blank');
    } else {
      navigate(href);
    }
  };

  return (
    <>
      {tabs.map((tab) => (
        <Grid
          key={tab.name}
          item
          xs={tab.name.length > 8 ? 3 : 2}
          sm={tab.name.length > 8 ? 3 : 2}
          align="center"
        >
          <Button
            style={{ color: '#484848' }}
            variant={location.pathname === tab.href ? 'outlined' : 'text'}
            onClick={() => handleRoute(tab.href, tab.external)}
          >
            {tab.name}
          </Button>
        </Grid>
      ))}
    </>
  );
};

WebMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabs: PropTypes.array.isRequired,
};

export default WebMenu;
